<template>
  <div>
    <svg
      id="Group_820"
      data-name="Group 820"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 30 30"
    >
      <path
        id="Path_1622"
        data-name="Path 1622"
        :fill="color"
        d="M25.607,19.393a14.942,14.942,0,0,0-5.7-3.575,8.672,8.672,0,1,0-9.813,0A15.024,15.024,0,0,0,0,30H2.344a12.656,12.656,0,1,1,25.312,0H30A14.9,14.9,0,0,0,25.607,19.393ZM15,15a6.328,6.328,0,1,1,6.328-6.328A6.335,6.335,0,0,1,15,15Z"
        transform="translate(0)"
      />
    </svg>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Account_Icon",
  props: {
    color: {
      default: "#1C274C",
    },
    size: {
      default: 30,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
  },
};
</script>

<style>
</style>